import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, push, limitToLast } from "firebase/database";

const bookingLocationUnsubscribers = {};

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;

    if (!trackingRef) {
      console.warn('Database not available, cannot save tracking');
      return;
    }

    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });

    if (!bookingId || !trackingRef) {
        dispatch({
            type: FETCH_BOOKING_LOCATION_FAILED,
            payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
        });
        return;
    }

    if (bookingLocationUnsubscribers[bookingId]) {
        bookingLocationUnsubscribers[bookingId]();
        delete bookingLocationUnsubscribers[bookingId];
    }
    
    // Écouter en temps réel la dernière position du chauffeur
    bookingLocationUnsubscribers[bookingId] = onValue(query(trackingRef(bookingId), limitToLast(1)), (snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            
            // Prendre toujours la dernière location disponible
            if (locations.length >= 1) {
                const lastLocation = locations[locations.length - 1];
                console.log('fetchBookingLocations: New location received', {
                    lat: lastLocation.lat,
                    lng: lastLocation.lng,
                    status: lastLocation.status,
                    at: lastLocation.at
                });
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: lastLocation
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    if (bookingLocationUnsubscribers[bookingId]) {
        bookingLocationUnsubscribers[bookingId]();
        delete bookingLocationUnsubscribers[bookingId];
    }
}

export const saveUserLocation = (location) => {
    const {
      auth,
      userLocationRef,
    } = firebase;

    if (!userLocationRef || !auth || !auth.currentUser) {
      console.warn('Database not available, cannot save user location');
      return;
    }

    const uid = auth.currentUser.uid;
    // Ajouter le timestamp de dernière mise à jour
    const locationWithTimestamp = {
      ...location,
      lastLocationUpdate: new Date().getTime()
    };
    set(userLocationRef(uid), locationWithTimestamp);
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}